export default __webpack_public_path__ + "static/media/napa-logo_fr.019faa1c.png";